import { service } from '@ember/service';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class ReservationFilterAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;

  buildURL(): string {
    const marketId = this.hotelAndMarketService.market.id!;

    return `${this.host}/${APIGATEWAY}/reservations/market/${marketId}/filters/?market_id=${marketId}`;
  }
}
